import React, { useEffect, useState } from 'react';
import { PAGES } from '../seoPages';
import SeoPage from './SeoPage';
import FeedbackModal from './FeedbackModal';

function HowToPlay() {
  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    const onClick = (e) => {
      if (e.target.closest('#how-to-contact')) {
        e.preventDefault();
        setShowContact(true);
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return (
    <>
      <SeoPage page={PAGES.howTo} />
      {showContact && (
        <FeedbackModal
          onClose={() => setShowContact(false)}
          source="contact"
          title="Contact"
        />
      )}
    </>
  );
}

export default HowToPlay;
